import { render, staticRenderFns } from "./scammers.vue?vue&type=template&id=3e68e97f"
import script from "./scammers.vue?vue&type=script&lang=js"
export * from "./scammers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports